export Tabs from './Tabs'
export {default as TabBar} from './Tabs'
export Tab from './Tab'

export default from './Tabs'



// WEBPACK FOOTER //
// ./src/Tabs/index.js